import styled from "@emotion/styled"
import { sizer } from "@ninjaone/utils"

export const StyledInputWrapper = styled.div`
  position: relative;
`

export const StyledErrorIcon = styled.div`
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  padding-right: ${sizer(3)};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.red};
`
